import { Inject, Injectable } from "@angular/core";
import {
    AppMetaData, AppMetaDataItemNames, ProcessorConfigEntity, ProcessorConfigQueryBuilder,
    PaymentMethodEntity,
    SubscriptionTierBenefitEntity, SubscriptionStatusAllItems,
    SubscriptionTierBenefitQueryBuilder,
    RoSchoolSubscriptionEntity,
    SubscriptionEntity,
    RoSchoolBillingDetailsEntity,
    CoursePurchaseEntity,
    RoStudentPaymentMethodEntity, RoSchoolPaymentMethodEntity,
    ProfitSharingTotalsBySchoolQueryEntity,
    SubscriptionTierEntity,
    SubscriptionDetailsQueryEntity
} from "../../../meta-data/app-meta-data.service";
import {
    DevwareMetaData, DwCacheService, DwConfigService, DwConfigServiceToken, DwEventService,
    DwField,
    DwMetaDataService, DwMetaDataServiceToken, DwOrmData, DwOrmDataService, DwOrmDataServiceToken,
    DwQueryHelper,
    DwQueryRelation,
    DwSecurityTopics, DwSecurityUserService, SuppressErrorMessagesHeader, areEqual, deepCopy
} from "@devwareapps/devware-cap";
import { AdminManagerService } from 'src/app/features/admin/services/admin-manager.service';
import { Observable, combineLatest, of } from "rxjs";
import { Router } from "@angular/router";
import { map, mergeMap, tap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

import { CreateCustomerResult } from "src/app/features/payments/models/create-customer-result.model";

import * as moment from "moment";
import { PaymentCustomerDetailsResult } from "../models/payment-customer-details-result.model";
import { PaymentCustomerDetailsRequest } from "../models/payment-customer-details-request.model";
import { PaymentParty } from "../models/payment-party.enum";
import { RemovePaymentMethodRequest } from "../models/remove-payment-method-request.model";
import { ApiActionResult } from "../models/api-action-result.model";
import { SubscriptionChangeStartRequest } from "../models/subscriptions/subscription-change-start-request.model";
import { SubscriptionChangeStartResult } from "../models/subscriptions/subscription-change-start-result.model";
import { SubscriptionChangeCompleteRequest } from "../models/subscriptions/subscription-change-complete-request.model";
import { SubscriptionChangeCompleteResult } from "../models/subscriptions/subscription-change-complete-result.model";
import { SubscriptionCurrentDetails } from "../models/subscriptions/subscription-current-details.model";


export const SUBSCRIPTION_CHANGED_TOPC = 'subscription-changed';
@Injectable({ providedIn: 'root' })
export class PaymentsRepositoryService {

    paymentsApi: string;

    constructor(@Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        @Inject(DwConfigServiceToken) private configService: DwConfigService,
        private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,
        private adminManagerService: AdminManagerService,
        private dwEventService: DwEventService,
        private router: Router,
        private http: HttpClient
    ) {
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/payments`;
    }

    // getProcessorConfigBySchool(flightSchoolId: number): Observable<ProcessorConfigEntity> {
    //     const query = AppMetaData.ProcessorConfig.CreateQueryBuilder();
    //     query.query.FieldSettings.LoadAllLookupDisplayFields = true;
    //     query.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));
    //     return this.dwOrmDataService.executeQuerySingle(query);
    // }
    // getProcessorConfigByUser(userId: number): Observable<ProcessorConfigEntity> {
    //     const query = AppMetaData.ProcessorConfig.CreateQueryBuilder();
    //     query.query.FieldSettings.LoadAllLookupDisplayFields = true;
    //     query.addFilterAnd(f => f.Equal(a => a.UserId, userId));
    //     return this.dwOrmDataService.executeQuerySingle(query);
    // }

    getProcessorConfig(paymentParty: PaymentParty): Observable<PaymentCustomerDetailsResult> {
        const cacheInvalidationTopics: string[] = [DwSecurityTopics.SECURITY_CHANGED];

        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.SubscriptionTierBenefit));

        const key = `currentProcessorConfig_${paymentParty}`;

        return this.dwCacheService.get(key, this.loadCustomerDetails(paymentParty), null, cacheInvalidationTopics);
    }

    private loadCustomerDetails(paymentParty: PaymentParty): Observable<PaymentCustomerDetailsResult> {
        const url = `${this.paymentsApi}/get-customer-details`;

        var request: PaymentCustomerDetailsRequest = {
            PaymentParty: paymentParty
        }
        return this.http.post<PaymentCustomerDetailsResult>(url, request);
    }

    removePaymentMethod(paymentMethodId: number, paymentParty: PaymentParty): Observable<ApiActionResult> {
        const url = `${this.paymentsApi}/remove-payment-method`;

        var request: RemovePaymentMethodRequest = {
            PaymentMethodId: paymentMethodId,
            PaymentParty: paymentParty
        }

        return this.http.post<ApiActionResult>(url, request);
    }

    // getCreateProcessorConfig(forUser: boolean = false): Observable<ProcessorConfigEntity> {
    //     const aviatorUser = this.adminManagerService.getAviatorUser();
    //     const u = aviatorUser?.user;
    //     const email = u?.Email;
    //     const name = `${u?.FirstName} ${u?.LastName}`;
    //     const obs: Observable<ProcessorConfigEntity> = forUser == false ?
    //         this.getProcessorConfigBySchool(aviatorUser.FlightSchoolId) :
    //         this.getProcessorConfigByUser(aviatorUser.user.UserId);
    //     return obs.pipe(mergeMap(cfg => {
    //         if (cfg != undefined)
    //             return of(cfg);
    //         const url = `${this.paymentsApi}/create-customer`;
    //         return this.http
    //             .post<CreateCustomerResult>(url, { Email: email, Name: name })
    //             .pipe(mergeMap(resp => {
    //                 let newCfg: ProcessorConfigEntity = {
    //                     _itemName: AppMetaDataItemNames.ProcessorConfig,
    //                     FlightSchoolId: forUser ? undefined : aviatorUser.FlightSchoolId,
    //                     UserId: forUser ? aviatorUser.user.UserId : undefined,
    //                     CustomerId: resp.Id,
    //                 };
    //                 return this.saveConfig(newCfg);
    //             }));
    //     }))
    // }

    getSubBenefits(): Observable<SubscriptionTierBenefitEntity[]> {
        const cacheInvalidationTopics: string[] = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.SubscriptionTierBenefit));
        const courseKey = `SubscriptionTierBenefits`;
        return this.dwCacheService.get(courseKey, this.loadSubBenefits(), null, cacheInvalidationTopics);
    }

    getSubriptionTiers(): Observable<SubscriptionTierEntity[]> {
        const cacheInvalidationTopics: string[] = [];

        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.SubscriptionTierBenefit));

        const courseKey = `SubscriptionTier`;
        return this.dwCacheService.get(courseKey, this.loadSubriptionTiers(), null, cacheInvalidationTopics);
    }

    getCurrentSubscriptionNOT_USED(flightSchoolId: number):Observable<{ active: SubscriptionDetailsQueryEntity, future: SubscriptionDetailsQueryEntity}> {
        return AppMetaData.Queries.SubscriptionDetails.CreateQueryBuilder(this.dwMetaDataService)
            .pipe(mergeMap(q => {
                const qh = new DwQueryHelper();
                q.query = qh.cloneQuery(q.query);

                q.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));

                q.addFilterAnd(f => f.InList(a => a.SubscriptionStatusId, [SubscriptionStatusAllItems.Active, SubscriptionStatusAllItems.Future]));

                return this.dwOrmDataService.executeQuery(q)
                    .pipe(map((subs: SubscriptionDetailsQueryEntity[]) => {
                        const active = subs.find(s => s.SubscriptionStatusId == SubscriptionStatusAllItems.Active);
                        const future = subs.find(s => s.SubscriptionStatusId == SubscriptionStatusAllItems.Future);
                        return { active, future };
                    }));
            }));
    }


    private loadSubriptionTiers(): Observable<SubscriptionTierBenefitEntity[]> {

        return AppMetaData.Queries.SubscriptionTierActive.CreateQueryBuilder(this.dwMetaDataService)
            .pipe(mergeMap(q => {
                q.addPrefetch(r => r.SubscriptionTierBenefit);

                return this.dwOrmDataService.executeQuery(q);
            }));
        const query = AppMetaData.SubscriptionTier.CreateQueryBuilder();

        query.addPrefetch(r => r.SubscriptionTierBenefit);

        return this.dwOrmDataService.executeQuery(query);
    }

    private loadSubBenefits(): Observable<SubscriptionTierBenefitEntity[]> {
        const query = AppMetaData.SubscriptionTierBenefit.CreateQueryBuilder();
        query.addPrefetch(r => r.SubscriptionTier);
        return this.dwOrmDataService.executeQuery(query);
    }

    getRoSchoolSub(flightSchoolId: number): Observable<RoSchoolSubscriptionEntity> {
        return this.loadRoSchoolSub(flightSchoolId);
    }
    private loadRoSchoolSub(flightSchoolId: number): Observable<RoSchoolSubscriptionEntity> {
        const querySub = AppMetaData.Subscription.CreateQueryBuilder();
        querySub.addPrefetch(r => r.Discount)
        const query = AppMetaData.RoSchoolSubscription.CreateQueryBuilder();
        query.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));
        query.addPrefetch(r => r.Subscription, querySub.query);
        query.addPrefetch(r => r.SubscriptionByPendingSubscriptionId);
        query.addPrefetch(r => r.SubscriptionByPreviousSubscriptionId);
        query.addOrderByDesc(i => i.SubscriptionId);
        return this.dwOrmDataService.executeQuerySingle(query);
    }
    getRoStudentPaymentMethods(): Observable<RoStudentPaymentMethodEntity[]> {
        const aviatorUser = this.adminManagerService.getAviatorUser();
        const id: number = aviatorUser?.user.UserId;

        const query = AppMetaData.RoStudentPaymentMethod.CreateQueryBuilder();
        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        query.addFilterAnd(f => f.Equal(a => a.UserId, id));
        return this.dwOrmDataService.executeQuery(query);
    }
    getRoSchoolPaymentMethods(): Observable<RoSchoolPaymentMethodEntity[]> {
        const aviatorUser = this.adminManagerService.getAviatorUser();
        const id: number = aviatorUser?.FlightSchoolId;

        const query = AppMetaData.RoSchoolPaymentMethod.CreateQueryBuilder();
        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        query.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, id));
        return this.dwOrmDataService.executeQuery(query);
    }

    getPaymentMethods(asSchool: boolean = true): Observable<PaymentMethodEntity[]> {
        const aviatorUser = this.adminManagerService.getAviatorUser();
        const id: number = asSchool ? aviatorUser.FlightSchoolId : aviatorUser?.user.UserId;
        // const obs: Observable<ProcessorConfigEntity> =
        //     asSchool ? this.getProcessorConfigBySchool(id) : this.getProcessorConfigByUser(id);

        return this.getProcessorConfig(asSchool ? PaymentParty.FlightSchool : PaymentParty.Student).pipe(mergeMap(cfg => {
            if (cfg == undefined)
                return of([]);
            return this.loadSchoolPaymentMethods(cfg.ProcessorConfigId);
        }));
    }
    getPaymentMethodsForConfig(cfg: ProcessorConfigEntity): Observable<PaymentMethodEntity[]> {
        return this.loadSchoolPaymentMethods(cfg.ProcessorConfigId);
    }
    private loadSchoolPaymentMethods(processorConfigId: number): Observable<PaymentMethodEntity[]> {
        const query = AppMetaData.PaymentMethod.CreateQueryBuilder();
        query.addFilterAnd(f => f.Equal(a => a.ProcessorConfigId, processorConfigId));
        query.addFilterAnd(f => f.Equal(a => a.IsActive, true));
        return this.dwOrmDataService.executeQuery(query);
    }

    getBillingDetails(flightSchoolId: number): Observable<RoSchoolBillingDetailsEntity[]> {
        const query = AppMetaData.RoSchoolBillingDetails.CreateQueryBuilder();
        query.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));
        query.addPrefetch(r => r.FlightSchool);
        query.addPrefetch(r => r.SubscriptionByTier);
        query.addPrefetch(r => r.SubscriptionRole);
        return this.dwOrmDataService.executeQuery(query);
        0
    }

    getProfitSharingDetails(flightSchoolId: number, year?: number): Observable<ProfitSharingTotalsBySchoolQueryEntity[]> {

        if (!year) {
            year = new Date().getFullYear();
        }

        return AppMetaData.Queries.ProfitSharingTotalsBySchool.CreateQueryBuilder(this.dwMetaDataService)
            .pipe(mergeMap(q => {
                q.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));
                q.addFilterAnd(f => f.Equal(a => a.Year, year));
                // q.addFields(f => [f.FlightSchoolName.fieldNameWithItemPrefix, f.Month, f.Year, f.ProfitShareType, f.Sum]);

                return this.dwOrmDataService.executeQuery(q);
            }));
    }

    getProfitSharingRates(flightSchoolId: number): Observable<number> {
        const query = AppMetaData.FlightSchool.CreateQueryBuilder();
        query.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));
        query.addFilterAnd(f => f.Equal(a => AppMetaData.Subscription.Attributes.SubscriptionStatusId, SubscriptionStatusAllItems.Active));

        const psPercentfield = new DwField();
        psPercentfield.FullFieldName = AppMetaData.SubscriptionTier.Attributes.ProfitSharingPercentage.fieldNameWithItemPrefix;
        psPercentfield.FieldAlias = AppMetaData.SubscriptionTier.Attributes.ProfitSharingPercentage.fieldName;

        const relation: DwQueryRelation = {
            RelationName: AppMetaData.FlightSchool.Relations.Subscription.relationName,
            SubRelations: [{
                RelationName: AppMetaData.Subscription.Relations.SubscriptionTier.relationName,
                RelationFields: [psPercentfield]
            }]
        }

        query.query.AddRelation(relation);

        query.addField(f => f.ProfitSharingPercentageOverride);
        //query.addField(f => AppMetaData.SubscriptionTier.Attributes.ProfitSharingPercentage);

        return this.dwOrmDataService.executeQuerySingle(query)
            .pipe(map(s => {
                if (s.ProfitSharingPercentageOverride) {
                    return s.ProfitSharingPercentageOverride;
                }
                if ((s as any).ProfitSharingPercentage) {
                    return (s as any).ProfitSharingPercentage
                }
                return 0;
            }));
    }

    getPriorPendingSub(flightSchoolId: number): Observable<SubscriptionEntity> {
        return this.loadSchoolSubs(flightSchoolId)
            .pipe(mergeMap(s => this.loadRoSchoolSub(flightSchoolId).pipe(map(r => [s, r]))))
            .pipe(mergeMap(results => {
                const subs = results[0] as SubscriptionEntity[];
                const ro = results[1] as RoSchoolSubscriptionEntity;
                if (subs.length == 1) return of(null);
                const newest = subs[0];
                const recent = subs[1];
                const newestIsPrior =
                    newest.SubscriptionStatusId == SubscriptionStatusAllItems.Inactive &&
                    newest.EffectiveEndDate == undefined;
                const recentIsActive =
                    recent.SubscriptionId == ro.SubscriptionId &&
                    recent.SubscriptionStatusId == SubscriptionStatusAllItems.Active;
                return of(newestIsPrior && recentIsActive ? newest : null);
            }));
    }

    getSchoolSubs(flightSchoolId: number): Observable<SubscriptionEntity[]> {
        const cacheInvalidationTopics: string[] = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Subscription));
        const courseKey = `Subscriptions_${flightSchoolId}`;
        return this.dwCacheService.get(courseKey, this.loadSchoolSubs(flightSchoolId), null, cacheInvalidationTopics);
    }
    private loadSchoolSubs(flightSchoolId: number): Observable<SubscriptionEntity[]> {
        const query = AppMetaData.Subscription.CreateQueryBuilder();
        query.addFilterAnd(f => f.Equal(a => a.FlightSchoolId, flightSchoolId));
        query.addOrderByDesc(s => s.SubscriptionId);
        return this.dwOrmDataService.executeQuery(query);
    }

    undoPendingSub(flightSchoolId: number): Observable<RoSchoolSubscriptionEntity> {
        return this.getRoSchoolSub(flightSchoolId)
            .pipe(mergeMap(r => {
                if (r.PreviousSubscriptionId != undefined) {
                    r.PreviousSubscription.SubscriptionStatusId = SubscriptionStatusAllItems.Active;
                    r.PreviousSubscription.EffectiveEndDate = null;
                    r.Subscription.Pending = false;
                    r.Subscription.SubscriptionStatusId = SubscriptionStatusAllItems.Inactive;
                    return this.saveSubscriptions([r.Subscription, r.PreviousSubscription]);
                }
                else {
                    const none: SubscriptionEntity[] = [];
                    return of(none);
                }
            }))
            .pipe(mergeMap(s => this.getRoSchoolSub(flightSchoolId)));
    }

    switchSubscriptionTo(currentSub: RoSchoolSubscriptionEntity, pending: SubscriptionEntity): Observable<SubscriptionEntity[]> {
        //1. Save Current & Pending Sub updates
        const updates: SubscriptionEntity[] = [currentSub.Subscription, pending];
        return this.dwOrmDataService.saveEntityCollection(updates, false)
            .pipe(map(i => {
                this.loadSchoolSubs(currentSub.FlightSchoolId)
                    .subscribe(subs => {
                        //2. Set all existing subs to: Inactive & EffectiveEndDate to today if null
                        const targets = subs.filter(s =>
                            s.SubscriptionStatusId == SubscriptionStatusAllItems.Active &&
                            s.SubscriptionId != i[1].SubscriptionId);
                        targets.forEach(s => {
                            const endDate = s.EffectiveEndDate ??
                                moment(new Date()).add(-1, 'days').utc().format('YYYY-MM-DD');
                            s.EffectiveEndDate = endDate
                            s.SubscriptionStatusId = SubscriptionStatusAllItems.Inactive;
                        });
                        this.saveSubscriptions(targets).subscribe();
                    });
                return i;
            }));
    }
    deleteSubscription(sub: SubscriptionEntity): Observable<SubscriptionEntity> {
        return this.dwOrmDataService.deleteEntity(sub, false);
    }
    deletePaymentMethod(pm: PaymentMethodEntity): Observable<PaymentMethodEntity> {
        return this.dwOrmDataService.deleteEntity(pm, false);
    }
    saveSubscription(sub: SubscriptionEntity): Observable<SubscriptionEntity> {
        return this.dwOrmDataService.saveEntity(sub, false)
            .pipe(tap(s => {
                this.dwEventService.publishEvent(SUBSCRIPTION_CHANGED_TOPC, {});
            }))
    }
    saveSubscriptions(subs: SubscriptionEntity[]): Observable<SubscriptionEntity[]> {
        return this.dwOrmDataService.saveEntityCollection(subs, false, false)
            .pipe(tap(s => {
                this.dwEventService.publishEvent(SUBSCRIPTION_CHANGED_TOPC, {});
            }))
    }
    savePaymentMethods(pms: PaymentMethodEntity[]): Observable<PaymentMethodEntity[]> {
        return this.dwOrmDataService.saveEntityCollection(pms, false, false);
    }

    saveConfig(cfg: ProcessorConfigEntity): Observable<ProcessorConfigEntity> {
        return this.dwOrmDataService.saveEntity(cfg, false);
    }
    saveCoursePurchase(purchase: CoursePurchaseEntity): Observable<CoursePurchaseEntity> {
        return this.dwOrmDataService.saveEntity(purchase, true, null, null, true);
    }
    savePayment(cfg: PaymentMethodEntity): Observable<PaymentMethodEntity> {
        return this.dwOrmDataService.saveEntity(cfg, false);
    }


    applySubscriptionDiscountCode(subscriptionId: number, targetCode: string) {
        const url = `${this.paymentsApi}/apply-discount-sub/${subscriptionId}/${targetCode}`;

        this.http.get(url)
            .subscribe(r => {
            });
    }

    
    getCurrentSubscriptionDetails(): Observable<SubscriptionCurrentDetails> {
        const url = `${this.paymentsApi}/subscriptions/current`;

        return this.http.get<SubscriptionCurrentDetails>(url);
    }

    subscriptionChangeStart(request: SubscriptionChangeStartRequest): Observable<SubscriptionChangeStartResult> {
        const url = `${this.paymentsApi}/subscriptions/change-start`;

        return this.http.post<SubscriptionChangeStartResult>(url, request);
    }

    subscriptionChangeComplete(request: SubscriptionChangeCompleteRequest): Observable<SubscriptionChangeCompleteResult> {
        const url = `${this.paymentsApi}/subscriptions/change-complete`;

        return this.http.post<SubscriptionChangeCompleteResult>(url, request);
    }

}